import * as React from 'react'
import { useRef, memo, useLayoutEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { RootState } from '../../store/rootReducer'

import { MaterialsType } from '../../store/tags/tagsTyping'

import { switchIsNecessaryToGetAvatarFromContributionOnFalse } from '../../store/common/commonSlice'
import { isUserPro } from '../../utils/isUserPro'
import './styles.sass'

interface Props {
    material: MaterialsType
    isAgeVerified?: boolean
    isIndex?: boolean
}

const MaterialItem: React.FunctionComponent<Props> = ({ material, isAgeVerified = false, isIndex = false }: Props) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()

    const { user } = useSelector((state: RootState) => state.member)

    const ref = useRef(null)

    useLayoutEffect(() => {
        if (typeof document === 'object' && material.width) {
            const grid = document.getElementsByClassName('grid')[0]
            const gridColumnWidth = window
                .getComputedStyle(grid)
                .getPropertyValue('grid-template-columns')
                .toString()
                .split(' ')
                .pop()
                .split('px')
                .shift()

            const imgWidth = Number(gridColumnWidth)
            const widthRation = imgWidth / Number(material.width)
            const imgHeight = Math.floor(Number(material.height) * widthRation)
            ref.current.height = imgHeight
        }
    }, [])

    return (
        <Link
            className="contributionMaterial"
            to={{
                pathname: isAgeVerified ? material.page_url : ''
            }}
            onClick={() => dispatch(switchIsNecessaryToGetAvatarFromContributionOnFalse())}
        >
            <img
                onClick={(e) => {
                    if (isIndex) {
                        e.preventDefault()
                        history.push(location.pathname + `?id=${material.id}`)
                    }
                }}
                className={
                    (!user || !isUserPro(user.member_type)) &&
                    material.pro === 1 &&
                    !isIndex &&
                    !(user && user.id == material.user_id)
                        ? 'onlyForPro'
                        : ''
                }
                ref={ref}
                src={material.thumbnail_url}
                alt=""
                onError={() => (ref.current.src = require('./../../assets/404.png'))}
            />
        </Link>
    )
}

export default memo(MaterialItem)
